require("bootstrap-sass");

window.bootbox = require("bootbox");
require("bootstrap-toggle/js/bootstrap-toggle");
window.toastr = require("toastr");